var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadExort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download-exort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-115.000000, -100.000000)",
    fill: "#14B497",
    stroke: "#14B497",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "download-exort",
    transform: "translate(115.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.112,8.034 C17.9777177,8.03426354 17.8490696,8.0879976 17.7544935,8.1833243 C17.6599174,8.278651 17.607202,8.40771977 17.608,8.542 L17.608,13.171 C17.611325,14.4245641 16.599551,15.4443893 15.346,15.451 L4.27,15.451 C3.01644897,15.4443893 2.004675,14.4245641 2.008,13.171 L2.008,8.467 C2.01626517,8.28140126 1.92195657,8.10625196 1.76245968,8.01098419 C1.60296279,7.91571641 1.40403721,7.91571641 1.24454032,8.01098419 C1.08504343,8.10625196 0.990734826,8.28140126 0.999,8.467 L0.999,13.171 C0.999,14.991 2.469,16.469 4.27,16.469 L15.345,16.469 C17.151,16.469 18.616001,14.987 18.616001,13.171 L18.616001,8.542 C18.6165537,8.2623807 18.3906177,8.03510249 18.111,8.034 L18.112,8.034 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.453,12.428 C9.54549424,12.5252182 9.67381143,12.5802501 9.808,12.5802501 C9.94218857,12.5802501 10.0705058,12.5252182 10.163,12.428 L13.372,9.195 C13.5703362,8.99597631 13.5703362,8.67402369 13.372,8.475 C13.2779659,8.3791052 13.1493064,8.32507285 13.015,8.32507285 C12.8806936,8.32507285 12.7520341,8.3791052 12.658,8.475 L10.313,10.842 L10.313,0.518 C10.313,0.33758087 10.2167476,0.170866714 10.0605,0.080657146 C9.90425246,-0.00955242214 9.71174754,-0.00955242214 9.55549999,0.080657146 C9.39925244,0.170866714 9.30299999,0.33758087 9.303,0.518 L9.303,10.842 L6.957,8.475 C6.86296592,8.3791052 6.73430645,8.32507285 6.6,8.32507285 C6.46569355,8.32507285 6.33703408,8.3791052 6.243,8.475 C6.04466378,8.67402369 6.04466378,8.99597631 6.243,9.195 L9.454,12.428 L9.453,12.428 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExort);
export default __webpack_public_path__ + "static/media/download-exort.3266df29c1bb3969412a598610571ecd.svg";
export { ForwardRef as ReactComponent };